import noop from 'lodash/noop'

if (process.env.DEV_ENV === 'production') {
  const console = {}
  console.log = noop
  console.info = noop
  console.error = noop
  console.warn = noop
  window.console = console
}

/*
//
//  FUTURE:  Catch errors and send to logging service
//  https://stackoverflow.com/questions/7042611/override-console-log-for-production
//

// define a new console
var console=(function(oldCons){
  return {
      log: function(text){
          oldCons.log(text);
          // Your code
      },
      info: function (text) {
          oldCons.info(text);
          // Your code
      },
      warn: function (text) {
          oldCons.warn(text);
          // Your code
      },
      error: function (text) {
          oldCons.error(text);
          // Your code
      }
  };
}(window.console));

//Then redefine the old console
window.console = console;
*/
